const userAgent: string = navigator.userAgent || (window as any).opera;

const isMobileDevice = (): boolean => {
    const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i];
    return regexs.some((b) => userAgent.match(b));
}

const isTabletDevice = (): boolean => {
    const regex = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/;
    return regex.test(userAgent.toLowerCase());
}

const isDesktopDevice = (): boolean => !isMobileDevice() && !isTabletDevice();

enum MobileOS {
    Android = 'android',
    iOS = 'ios',
    Unknown = 'unknown',
    WindowsPhone = 'Windows Phone'
};

enum DesktopOS {
    Linux = 'linux',
    MacOS = 'mac_os',
    Unix = 'unix',
    Unknown = 'unknown',
    Windows = 'windows'
};
  
const getMobileOS = (): MobileOS | undefined => {
    if (isMobileDevice()) {
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) return MobileOS.WindowsPhone;
        else if (/android/i.test(userAgent)) return MobileOS.Android;

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) return MobileOS.iOS;

        return MobileOS.Unknown;
    } 
    else {
        return undefined;
    }
}

const getDesktopOS = (): DesktopOS | undefined => {
    if (isDesktopDevice()) {
        if (userAgent.indexOf('Win') !== -1) return DesktopOS.Windows;
        else if (userAgent.indexOf('Mac') !== -1) return DesktopOS.MacOS;
        else if (userAgent.indexOf('X11') !== -1) return DesktopOS.Unix;
        else if (userAgent.indexOf('Linux') !== -1) return DesktopOS.Linux;
        
        return DesktopOS.Unknown;
    }
    else {
        return undefined;
    }
}

type DeviceOS = DesktopOS | MobileOS;

const useDeviceOS = (): DeviceOS | undefined => getMobileOS() ?? getDesktopOS();

export default useDeviceOS;